// Held back from the live site until the owner approves. Flip to true to release everywhere.
const RELEASED = false;
const host = typeof window !== "undefined" ? window.location.hostname : "";
const isPreview = host.includes("preview.emergentagent.com") || host === "localhost";

export const PROPERTY_IDEAS_ON = RELEASED || isPreview;
